export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#8FA088] text-white">
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/3212ef29-01d8-4e58-897f-85da0f24b6e3.png" 
                alt="마음쉼터" 
                className="h-8 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-[13px] text-white/80 leading-relaxed">
              마음이 쉬어가는 공간,<br />
              당신의 이야기를 보내드립니다.
            </p>
          </div>

          <div>
            <h4 className="text-[15px] font-semibold mb-3">바로가기</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('intro')} className="text-[13px] text-white/80 hover:text-white transition-colors cursor-pointer">
                  센터 소개
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('programs')} className="text-[13px] text-white/80 hover:text-white transition-colors cursor-pointer">
                  상담 프로그램
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('counselors')} className="text-[13px] text-white/80 hover:text-white transition-colors cursor-pointer">
                  상담사 안내
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('booking')} className="text-[13px] text-white/80 hover:text-white transition-colors cursor-pointer">
                  상담 예약
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[15px] font-semibold mb-3">상담 시간</h4>
            <ul className="space-y-2 text-[13px] text-white/80">
              <li>평일: 10:00 - 20:00</li>
              <li>토요일: 10:00 - 15:00</li>
              <li className="text-[12px] text-white/60">(사전예약 후 20:00까지 가능)</li>
              <li>일요일 및 공휴일: 휴무</li>
              <li className="pt-1 text-white/60 text-[12px]">
                * 예약제로 운영됩니다
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[15px] font-semibold mb-3">연락처</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-base"></i>
                <span className="text-[13px] text-white/80">010-4827-0275</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                <span className="text-[13px] text-white/80">eunmilee724@daum.net</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-base mt-0.5"></i>
                <span className="text-[13px] text-white/80">
                  경기도 평택시 중앙로 176<br />2동 2층 219호
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3">
            <p className="text-[12px] text-white/60">
              © 2024 마음쉼터 심리상담센터. All rights reserved.
            </p>
            
            <div className="flex gap-3">
              <a
                href="#"
                className="w-9 h-9 rounded-full border border-white/30 flex items-center justify-center hover:bg-white hover:text-[#8FA088] transition-all duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full border border-white/30 flex items-center justify-center hover:bg-white hover:text-[#8FA088] transition-all duration-300 cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-base"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full border border-white/30 flex items-center justify-center hover:bg-white hover:text-[#8FA088] transition-all duration-300 cursor-pointer"
                aria-label="KakaoTalk"
              >
                <i className="ri-kakao-talk-fill text-base"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
